import { useEffect, useState } from "react";
import ProductsService from "../api/services/products.service";
import { DeliverySettingsTypes } from "../api/types/products.types";

/**
 * The delivery charge as configured by the admin, converted into the currency
 * being shopped in.
 *
 * This is the one to use where there is no basket to quote against — a product
 * page, say — and it works for signed-out visitors. Once a basket exists,
 * useBasketDelivery is the right hook: only that knows whether the order has
 * already reached the free-delivery threshold.
 */
export const useDeliverySettings = (currencyId: number | null) => {
  const [delivery, setDelivery] = useState<DeliverySettingsTypes | null>(null);

  useEffect(() => {
    if (!currencyId) {
      setDelivery(null);
      return;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const res = await ProductsService.getDeliverySettings(
          Number(currencyId),
        );
        if (!cancelled) setDelivery(res.data);
      } catch (error) {
        // Delivery is additive information; failing to load it must not take
        // the surrounding page down.
        console.error("Could not load delivery settings:", error);
        if (!cancelled) setDelivery(null);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [currencyId]);

  return delivery;
};
